/**
 * Created by Jerker Nord on 2019-03-15.
 */
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {ThorBackground} from "./background/ThorBackground";
import {ThorFSThorNearWinController} from "./beforespinstoppresentation/fsthornearwin/ThorFSThorNearWinController";
import {ThorFSThorNearWinView} from "./beforespinstoppresentation/fsthornearwin/ThorFSThorNearWinView";
import {ThorHammertimeController} from "./beforespinstoppresentation/hammertime/ThorHammertimeController";
import {ThorRuneRazeController} from "./beforespinstoppresentation/runeraze/ThorRuneRazeController";
import {ThorScatterNearWinController} from "./beforespinstoppresentation/scatternearwin/ThorScatterNearWinController";
import {ThorScatterNearWinView} from "./beforespinstoppresentation/scatternearwin/ThorScatterNearWinView";
import {ThorBonusFeatureController} from "./beforespinstoppresentation/ThorBonusFeatureController";
import {ThorFSBonusFeatureAbortController} from "./beforespinstoppresentation/ThorFSBonusFeatureAbortController";
import {ThorFSBonusFeatureController} from "./beforespinstoppresentation/ThorFSBonusFeatureController";
import {ThorScatterNudgeController} from "./beforespinstoppresentation/ThorScatterNudgeController";
import {ThorExtraFSIconView} from "./featureIcons/extraFSIcon/ThorExtraFSIconView";
import {ThorMultiplierIconView} from "./featureIcons/multipliericon/ThorMultiplierIconView";
import {ThorRandomWildIconView} from "./featureIcons/randomwildicon/ThorRandomWildIconView";
import {ThorReelWildIconView} from "./featureIcons/reelwildicon/ThorReelWildIconView";
import {ThorGameShaker} from "./gameshake/ThorGameShaker";
import {ThorIntroView} from "./intro/ThorIntroView";
import {ThorLogo} from "./logo/ThorLogo";
import {ThorMjolnirtimeView} from "./mjolnirtime/ThorMjolnirtimeView";
import {ThorFreeSpinBoxView} from "./reel/freespinbox/ThorFreeSpinBoxView";
import {ThorNudgeReelPartAnimator} from "./reel/nudgereel/ThorNudgeReelPartAnimator";
import {ThorRespinNudgeReelController} from "./reel/nudgereel/ThorRespinNudgeReelController";
import {ThorReelView} from "./reel/reelarea/ThorReelView";
import {ThorReelBackgroundAreaView} from "./reel/reelbackground/ThorReelBackgroundAreaView";
import {ThorReelsFrame} from "./reel/reelframe/ThorReelsFrame";
import {ThorReelAreaView} from "./reel/ThorReelAreaView";
import {ThorExtraFreeSpinsController} from "./reelstoppresentation/extrafreespins/ThorExtraFreeSpinsController";
import {ThorFSBonusFeaturePlayingController} from "./reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorFSThorNearWinReelStopController} from "./reelstoppresentation/fsthornearwin/ThorFSThorNearWinReelStopController";
import {ThorMultiplierController} from "./reelstoppresentation/multiplier/ThorMultiplierController";
import {ThorMultiplierView} from "./reelstoppresentation/multiplier/ThorMultiplierView";
import {ThorRandomWildsController} from "./reelstoppresentation/randomwilds/ThorRandomWildsController";
import {ThorRandomWildsView} from "./reelstoppresentation/randomwilds/ThorRandomWildsView";
import {ThorReelWildsController} from "./reelstoppresentation/reelwilds/ThorReelWildsController";
import {ThorReelWildsView} from "./reelstoppresentation/reelwilds/ThorReelWildsView";
import {ThorScatterNearWinReelStopController} from "./reelstoppresentation/scatternearwin/ThorScatterNearWinReelStopController";
import {ThorScatterRespinController} from "./reelstoppresentation/scatterrespin/ThorScatterRespinController";
import {ThorFreeSpinIntroController} from "./screens/freespinintro/ThorFreeSpinIntroController";
import {ThorFreeSpinIntroView} from "./screens/freespinintro/ThorFreeSpinIntroView";
import {ThorFreeSpinOutroController} from "./screens/freespinoutro/ThorFreeSpinOutroController";
import {ThorFreeSpinOutroView} from "./screens/freespinoutro/ThorFreeSpinOutroView";
import {ThorParsedGameData} from "./server/data/ThorParsedGameData";
import {ThorParsedInitData} from "./server/data/ThorParsedInitData";
import {ThorServerDataParser} from "./server/ThorServerDataParser";
import {ThorSpinController} from "./spin/ThorSpinController";
import {ThorReelSymbol} from "./symbols/ThorReelSymbol";
import {ThorReelSymbolStateCreator} from "./symbols/ThorReelSymbolStateCreator";
import {ThorFontConfig} from "./ThorFontConfig";
import {ThorGameAssets} from "./ThorGameAssets";
import {ThorGameConfig} from "./ThorGameConfig";
import {ThorSoundConfig} from "./ThorSoundConfig";
import {ThorAnimatedWinlineController} from "./winpresentation/animatedwinlines/ThorAnimatedWinlineController";
import {ThorBigWinController} from "./winpresentation/bigwin/ThorBigWinController";
import {ThorFSExtraFSWPController} from "./winpresentation/fsextrafs/ThorFSExtraFSWPController";
import {ThorIndividualWPController} from "./winpresentation/individual/ThorIndividualWPController";
import {ThorInitialWPController} from "./winpresentation/initial/ThorInitialWPController";
import {ThorMultiplierWPController} from "./winpresentation/multiplier/ThorMultiplierWPController";
import {ThorNoWinHammerRuneWPController} from "./winpresentation/nowinhammerrune/ThorNoWinHammerRuneWPController";
import {ThorRandomWildsWPController} from "./winpresentation/randomwilds/ThorRandomWildsWPController";
import {ThorReelWildsWPController} from "./winpresentation/reelwilds/ThorReelWildsWPController";
import {ThorScatterNudgeWPController} from "./winpresentation/scatternudge/ThorScatterNudgeWPController";
import {ThorNudgeRespinFSZeroBetController} from "./zerobet/ThorNudgeRespinFSZeroBetController";
import {ThorNudgeRespinZeroBetController} from "./zerobet/ThorNudgeRespinZeroBetController";
import {ThorScatterRespinZeroBetController} from "./zerobet/ThorScatterRespinZeroBetController";

export class ThorGameModuleConfig implements IGameModuleConfig {

    public static instance:ThorGameModuleConfig = new ThorGameModuleConfig();

    public static background:ThorBackground;
    private static thorReelsFrame:ThorReelsFrame;
    private static thorAnimatedWinlineController:ThorAnimatedWinlineController;
    private static thorFSBonusFeatureAbortController:ThorFSBonusFeatureAbortController;
    public static thorMultiplierView:ThorMultiplierView;
    public static thorReelBackgroundAreaView:ThorReelBackgroundAreaView;
    public static thorRandomWildsView:ThorRandomWildsView;
    public static thorReelWildsView:ThorReelWildsView;
    public static thorMjolnirtimeView:ThorMjolnirtimeView;
    public static thorMultiplierIconView:ThorMultiplierIconView;
    public static thorRandomWildIconView:ThorRandomWildIconView;
    public static thorReelWildIconView:ThorReelWildIconView;
    public static thorExtraFSIconView:ThorExtraFSIconView;
    public static thorFreeSpinBoxView:ThorFreeSpinBoxView;
    public static thorRandomWildsController:ThorRandomWildsController;
    public static thorReelWildsController:ThorReelWildsController;
    public static thorMultiplierController:ThorMultiplierController;
    public static thorExtraFreeSpinsController:ThorExtraFreeSpinsController;
    public static thorScatterRespinController:ThorScatterRespinController;
    public static thorLogo:ThorLogo;
    private static thorGameShaker:ThorGameShaker;
    public static thorScatterNearWinView:ThorScatterNearWinView;
    public static thorFSThorNearWinView:ThorFSThorNearWinView;

    GAME_CONFIG:IGameConfig = ThorGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = ThorSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = ThorFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = ThorGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new ThorServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new ThorParsedInitData(data, <ThorServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new ThorParsedGameData(data, <ThorServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new ThorSpinController();
    REEL_AREA_VIEW:() => ReelAreaView = () => new ThorReelAreaView();
    REEL_VIEW:(reelId:number) => PIXI.Container = reelId => new ThorReelView(reelId);
    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new ThorRespinNudgeReelController(reelId);
    REEL_PART_ANIMATOR:(reelId:number) => SpinReelPartAnimator = reelId => new ThorNudgeReelPartAnimator(reelId);

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):ThorReelSymbol => {
            return new ThorReelSymbol(symName, 0, state);
        });
    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new ThorReelSymbolStateCreator();

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new ThorNudgeRespinZeroBetController(),
        () => new ThorNudgeRespinFSZeroBetController(),
        () => new ThorScatterRespinZeroBetController(),
        () => new FreespinZeroBetController(),
        () => new RespinZeroBetController()
    ];

    INTRO_VIEW:(onClickCallback:() => void) => ThorIntroView =
        (onClickCallback:() => void) => new ThorIntroView({
            layer : ThorGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : ThorGameAssets.MAIN_GAME_BACKGROUND},
            },
            mobileScale : 1.2,
            portraitScale : 1.7,
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_MEDIUM]
            }
        });

    SCREENS:(() => ScreenController)[] = [
        () => new ThorFreeSpinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new ThorFreeSpinIntroView({
                    layer : ThorGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.4
                }, autoClose);
            }
        }),
        () => new ThorFreeSpinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new ThorFreeSpinOutroView({
                    layer : ThorGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.4
                }, autoClose);
            }
        })
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS:((index:number) => BeforeSpinStopPresentationController)[] = [
        (index:number) => new ThorScatterNearWinController(index),
        (index:number) => new ThorFSThorNearWinController(index),
        (index:number) => new ThorRuneRazeController(index),
        (index:number) => new ThorHammertimeController(index),
        (index:number) => new ThorBonusFeatureController(index),
        (index:number) => new ThorFSBonusFeatureController(index),
        (index:number) => new ThorScatterNudgeController(index)
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new ThorScatterNearWinReelStopController(index),
        (index:number) => new ThorFSThorNearWinReelStopController(index),
        (index:number) => new ThorFSBonusFeaturePlayingController(index),
        (index:number) => ThorGameModuleConfig.thorScatterRespinController = new ThorScatterRespinController(index),
        (index:number) => ThorGameModuleConfig.thorRandomWildsController = new ThorRandomWildsController(index),
        (index:number) => ThorGameModuleConfig.thorReelWildsController = new ThorReelWildsController(index),
        (index:number) => ThorGameModuleConfig.thorMultiplierController = new ThorMultiplierController(index),
        (index:number) => ThorGameModuleConfig.thorExtraFreeSpinsController = new ThorExtraFreeSpinsController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new ThorScatterNudgeWPController(indexes)],
        [indexes => new ThorRandomWildsWPController(indexes)],
        [indexes => new ThorReelWildsWPController(indexes)],
        [indexes => new ThorMultiplierWPController(indexes)],
        [indexes => new ThorFSExtraFSWPController(indexes)],
        [indexes => new ThorInitialWPController(indexes)],
        [indexes => new ThorBigWinController(indexes)],
        [indexes => new ThorNoWinHammerRuneWPController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new ThorIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        ThorGameModuleConfig.background = new ThorBackground({
            layer : ThorGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : ThorGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                SCATTER_RESPIN : {image : ThorGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                NUDGE_RESPIN : {image : ThorGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                NUDGE_RESPIN_FS : {image : ThorGameAssets.FREESPIN_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {image : ThorGameAssets.FREESPIN_BACKGROUND, offset : new PIXI.Point(-480, -480)},

            },
            stretch : false
        });

        ThorGameModuleConfig.thorMultiplierIconView = new ThorMultiplierIconView();
        ThorGameModuleConfig.thorRandomWildIconView = new ThorRandomWildIconView();
        ThorGameModuleConfig.thorReelWildIconView = new ThorReelWildIconView();
        ThorGameModuleConfig.thorExtraFSIconView = new ThorExtraFSIconView();
        ThorGameModuleConfig.thorMultiplierView = new ThorMultiplierView(ResourcesGroupName.MAIN);
        ThorGameModuleConfig.thorReelsFrame = new ThorReelsFrame(ResourcesGroupName.MAIN);
        ThorGameModuleConfig.thorAnimatedWinlineController = new ThorAnimatedWinlineController();
        ThorGameModuleConfig.thorRandomWildsView = new ThorRandomWildsView(ResourcesGroupName.MAIN);
        ThorGameModuleConfig.thorReelWildsView = new ThorReelWildsView(ResourcesGroupName.MAIN);
        ThorGameModuleConfig.thorMjolnirtimeView = new ThorMjolnirtimeView();
        ThorGameModuleConfig.thorFreeSpinBoxView = new ThorFreeSpinBoxView();
        ThorGameModuleConfig.thorLogo = new ThorLogo();
        ThorGameModuleConfig.thorGameShaker = new ThorGameShaker();
        ThorGameModuleConfig.thorFSBonusFeatureAbortController = new ThorFSBonusFeatureAbortController();

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(ThorGameModuleConfig.instance) {
            throw new Error("BlankSlotGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}